import { Button } from '@osmosis/react-ui/components/Button';
import { Flex } from '@osmosis/react-ui/components/Box';
import { useColors } from '@osmosis/react-ui/hooks/useColors';
import React from 'react';
import { useIntl, IntlShape } from 'react-intl';
import { billingTitles } from '../../constants/formatMesage';

type Props = {
  activePlanLength: number;
  setActivePlanLength: (tab: number) => void;
  planLengths: number[];
};

type PlanLengthOption = {
  id: number;
  title: string;
  discount: null | number;
};

function getTitle(intervalLength: number, intl: IntlShape) {
  if (intervalLength === 1) {
    return intl.formatMessage(billingTitles.monthly);
  }

  if (intervalLength === 12) {
    return intl.formatMessage(billingTitles.yearly);
  }

  if (intervalLength % 12 === 0) {
    const years = intervalLength / 12;

    return intl.formatMessage(billingTitles.multipleYears, { count: years });
  }

  return intl.formatMessage(billingTitles.multipleMonths, {
    count: intervalLength,
  });
}

/**
 * Return Matrix Plans Tabs component.
 */
const MatrixPlanTabs = (props: Props) => {
  const { planLengths, activePlanLength, setActivePlanLength } = props;
  const intl = useIntl();
  const colors = useColors();

  const tabs = planLengths.map((planLength) => {
    return {
      id: planLength,
      title: getTitle(planLength, intl),
      discount: null,
    };
  });

  const handleTabClick = (index: number) => {
    setActivePlanLength(index);
  };

  const isActive = (tabId: number) => activePlanLength === tabId;

  return (
    <Flex justifyContent="center">
      <Flex
        justifyContent="center"
        backgroundColor={colors.gray5}
        padding={1}
        sx={{
          borderRadius: '40px',
        }}
      >
        {tabs.map((tab: PlanLengthOption) => (
          <Button
            bg={isActive(tab.id) ? 'black' : '#ebebeb'}
            color={isActive(tab.id) ? 'white' : 'black'}
            style={{
              cursor: 'pointer',
              borderRadius: '30px',
              margin: '0 1px',
            }}
            px={4}
            py={3}
            data-testid={`matrix-plan-length-${tab.id}`}
            key={tab.id}
            onClick={() => handleTabClick(tab.id)}
            aria-pressed={isActive(tab.id)}
          >
            <Flex flexDirection="column" alignItems="center">
              {tab.title}
              {tab.discount && (
                <span style={{ fontSize: '8px', fontWeight: 400 }}>
                  {tab.discount}
                </span>
              )}
            </Flex>
          </Button>
        ))}
      </Flex>
    </Flex>
  );
};

export default MatrixPlanTabs;
